import LoaderImage from "../../assets/images/loader.png";

const Loader = () => {
  return (
    <div id="loading">
      <div id="loading-center">
        <img src={LoaderImage} height={100} />
      </div>
    </div>
  );
};

export default Loader;
